import { ApiFeeType, ApiOperationBase } from 'api/rtk-api'
import { PresentationalTable } from 'components/core-v2'
import { Currency, formatCurrencyFull } from 'utilities/currency'

import { getFeeTypeName } from '../trade-fees-breakdown-tab/utils'

export interface FeeOperation extends ApiOperationBase {
  feeType: ApiFeeType
  value: number
}

const getRows = (operations: FeeOperation[]) =>
  operations.reduce((acc, op) => {
    const feeTypeName = getFeeTypeName(op.feeType)
    const existing = acc.find(row => row[0] === feeTypeName)

    if (existing) {
      existing[1] += op.value
    } else {
      acc.push([feeTypeName, op.value])
    }

    return acc
  }, [])

export interface FeeTableProps {
  currency: string
  operations: FeeOperation[]
}
export const FeeTable = ({ currency, operations }: FeeTableProps) => {
  const rows = getRows(operations).map(row => [
    row[0],
    formatCurrencyFull(row[1], currency as Currency)
  ])

  return (
    <PresentationalTable
      headerRow={['Type', 'Amount']}
      rowOptions={[
        { align: 'left', width: '90%' },
        { align: 'right', width: '10%' }
      ]}
      rows={rows}
    />
  )
}
